import Vue from 'vue'

import { BREAKPOINT, BREAKPOINT_FLUID } from '@/modules/api'

const reactorElement = document.createElement('div')
document.body.appendChild(reactorElement)

const reactor = new Vue({
  el: reactorElement,

  data: {
    screenWidth: 1024,
    screenHeight: 768,
  },

  mounted () {
    window.addEventListener('resize', this.updateScrenWidth)
    this.updateScrenWidth()
  },

  destroyed () {
    window.removeEventListener('resize', this.updateScrenWidth)
  },

  methods: {
    updateScrenWidth () {
      this.screenWidth = window.innerWidth
      this.screenHeight = window.innerHeight
    },
  },

  render (h) {
    return h('div')
  },
})

export default {
  computed: {
    isMobile () {
      return reactor.screenWidth <= BREAKPOINT.TABLET
    },
    isTablet () {
      return reactor.screenWidth > BREAKPOINT.TABLET && window.innerWidth <= BREAKPOINT.DESKTOP
    },
    isDesktop () {
      return reactor.screenWidth > BREAKPOINT.DESKTOP
    },
    isFluidTablet () {
      return reactor.screenWidth > BREAKPOINT_FLUID.TABLET
    },
    isFluidDesktop () {
      return reactor.screenWidth > BREAKPOINT_FLUID.DESKTOP
    },
  },
}



// WEBPACK FOOTER //
// ./src/utils/MediaDetector.js